import React from 'react';
import { connect } from 'react-redux';
import DatasetCohortSettingsDialog from './DatasetCohortSettingsDialog';
import CatalogueChangeConfirmation from './CatalogueChangeConfirmation';
import WorkflowChangeConfirmation from './WorkflowChangeConfirmation';
import DatasetTypeChangeConfirmationWizard from './DatasetTypeChangeConfirmationWizard';

const DatasetSettingsDialogs = ({
  allowCatalogueSwitch,
  allowCohortSettings,
  allowTypeSwitch,
  allowWorkflowChange,
  theme,
}) => (
  <>
    {allowCatalogueSwitch && (<CatalogueChangeConfirmation theme={theme} />)}
    {allowCohortSettings && (<DatasetCohortSettingsDialog theme={theme} />)}
    {allowTypeSwitch && (<DatasetTypeChangeConfirmationWizard theme={theme} />)}
    {allowWorkflowChange && (<WorkflowChangeConfirmation theme={theme} />)}
  </>
);

const mapStateToProps = ({
  auth: { role: { permissions: { datasets: { update } } } },
  datasetSettings: {
    confirmCatalogue, cohortSettings, confirmWizard, confirmWorkflow,
  },
}) => ({
  allowCatalogueSwitch: confirmCatalogue.open && update,
  allowCohortSettings: cohortSettings.open && update,
  allowTypeSwitch: confirmWizard.open && update,
  allowWorkflowChange: confirmWorkflow.open && update,
});

export default connect(mapStateToProps)(DatasetSettingsDialogs);
